enum AppleMobilePhoneDeviceModels {
    iPhoneSE = 'iPhoneSE',
    iPhone5 = 'iPhone5',
    iPhone5s = 'iPhone5s',
    iPhone6 = 'iPhone6',
    iPhone6Plus = 'iPhone6Plus',
    iPhone6s = 'iPhone6s',
    iPhone6sPlus = 'iPhone6sPlus',
    iPhone7 = 'iPhone7',
    iPhone7Plus = 'iPhone7Plus',
    iPhone8 = 'iPhone8',
    iPhone8Plus = 'iPhone8Plus',
    iPhoneX = 'iPhoneX',
    iPhoneXr = 'iPhoneXr',
    iPhoneXs = 'iPhoneXs',
    iPhoneXsMax = 'iPhoneXsMax',
    iPhone12 = 'iPhone12',
    iPhone12Mini = 'iPhone12Mini',
    iPhone12Pro = 'iPhone12Pro',
    iPhone12ProMax = 'iPhone12ProMax',
    iPhone13 = 'iPhone13',
    iPhone13Mini = 'iPhone13Mini',
    iPhone13Pro = 'iPhone13Pro',
    iPhone13ProMax = 'iPhone13ProMax',
    iPhone14 = 'iPhone14',
    iPhone14Pro = 'iPhone14Pro',
    iPhone14ProMax = 'iPhone14ProMax',
}

enum AppleMobileTabletDeviceModels {
    iPadAir = 'iPadAir',
    iPadAir2 = 'iPadAir2',
    iPadMini2 = 'iPadMini2',
    iPadMini3 = 'iPadMini3',
    iPadMini4 = 'iPadMini4',
    'iPadPro1gen9.7' = 'iPadPro1gen9.7',
    'iPadPro1gen12.9' = 'iPadPro1gen12.9',
    'iPadPro2gen10.5' = 'iPadPro2gen10.5',
    'iPadPro2gen12.9' = 'iPadPro2gen12.9',
    'iPadPro3gen11' = 'iPadPro3gen11',
    'iPadPro3gen12.9' = 'iPadPro3gen12.9',
}

export enum BiometricType {
    touch = 'touch',
    faceId = 'faceId',
}

function checkMobileDeviceModel() {
    let mobileDevice;
    let canvas;
    let gl;
    let glRenderer;
    let models: null | string;
    const devices = [
        [
            '640x1136',
            [
                AppleMobilePhoneDeviceModels.iPhone5,
                AppleMobilePhoneDeviceModels.iPhone5s,
            ],
        ],
        [
            '1536x2048',
            [
                AppleMobileTabletDeviceModels.iPadAir,
                AppleMobileTabletDeviceModels.iPadMini2,
                AppleMobileTabletDeviceModels.iPadMini3,
            ],
        ],
        ['750x1334', [AppleMobilePhoneDeviceModels.iPhone6]],
        [
            '1242x2208',
            [
                AppleMobilePhoneDeviceModels.iPhone6sPlus,
                AppleMobilePhoneDeviceModels.iPhone6Plus,
            ],
        ],
        [
            '1536x2048',
            [
                AppleMobileTabletDeviceModels.iPadAir2,
                AppleMobileTabletDeviceModels.iPadMini4,
            ],
        ],
        ['640x1136', [AppleMobilePhoneDeviceModels.iPhoneSE]],
        ['750x1334', [AppleMobilePhoneDeviceModels.iPhone6s]],
        ['1242x2208', [AppleMobilePhoneDeviceModels.iPhone6sPlus]],
        ['1536x2048', [AppleMobileTabletDeviceModels['iPadPro1gen9.7']]],
        ['2048x2732', [AppleMobileTabletDeviceModels['iPadPro2gen12.9']]],
        ['750x1334', [AppleMobilePhoneDeviceModels.iPhone7]],
        ['1242x2208', [AppleMobilePhoneDeviceModels.iPhone7Plus]],
        ['1668x2224', [AppleMobileTabletDeviceModels['iPadPro2gen10.5']]],
        ['2048x2732', [AppleMobileTabletDeviceModels['iPadPro2gen12.9']]],
        ['750x1334', [AppleMobilePhoneDeviceModels.iPhone8]],
        ['1242x2208', [AppleMobilePhoneDeviceModels.iPhone8Plus]],
        ['2048x2732', [AppleMobileTabletDeviceModels['iPadPro1gen12.9']]],
        ['1125x2436', [AppleMobilePhoneDeviceModels.iPhoneX]],
        ['828x1792', [AppleMobilePhoneDeviceModels.iPhoneXr]],
        ['1125x2436', [AppleMobilePhoneDeviceModels.iPhoneXs]],
        ['1242x2688', [AppleMobilePhoneDeviceModels.iPhoneXsMax]],
        ['1668x2388', [AppleMobileTabletDeviceModels.iPadPro3gen11]],
        ['2048x2732', [AppleMobileTabletDeviceModels['iPadPro3gen12.9']]],
        ['1170x2532', [AppleMobilePhoneDeviceModels.iPhone12]],
        ['1080x2340', [AppleMobilePhoneDeviceModels.iPhone12Mini]],
        ['11702532', [AppleMobilePhoneDeviceModels.iPhone12Pro]],
        ['1284x2778', [AppleMobilePhoneDeviceModels.iPhone12ProMax]],
        ['11702532', [AppleMobilePhoneDeviceModels.iPhone13]],
        ['1080x2340', [AppleMobilePhoneDeviceModels.iPhone13Mini]],
        ['1170x2532', [AppleMobilePhoneDeviceModels.iPhone13Pro]],
        ['1284x2778', [AppleMobilePhoneDeviceModels.iPhone13ProMax]],
        ['1170x2532', [AppleMobilePhoneDeviceModels.iPhone14]],
        ['1179x2556', [AppleMobilePhoneDeviceModels.iPhone14Pro]],
        ['1290x2796', [AppleMobilePhoneDeviceModels.iPhone14ProMax]],
    ];

    function getCanvas() {
        if (canvas == null) {
            canvas = document.createElement('canvas');
        }

        return canvas;
    }

    function getGl() {
        if (gl == null) {
            gl = getCanvas().getContext('experimental-webgl');
        }

        return gl;
    }

    function getResolution() {
        const ratio = window.devicePixelRatio || 1;
        return `${Math.min(screen.width, screen.height) * ratio}x${
            Math.max(screen.width, screen.height) * ratio
        }`;
    }

    function getGlRenderer() {
        if (glRenderer == null) {
            const debugInfo = getGl()?.getExtension(
                'WEBGL_debug_renderer_info',
            );
            glRenderer =
                debugInfo == null
                    ? 'unknown'
                    : getGl().getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
        }

        return glRenderer;
    }

    function getModels() {
        if (models == null) {
            const gpu = getGlRenderer();
            const matches = gpu.toLowerCase().match(/apple/i);
            const res = getResolution();
            models = 'unknown';
            if (matches) {
                for (let i = 0; i < devices.length; i += 1) {
                    const device = devices[i];
                    if (res === device[0]) {
                        // eslint-disable-next-line prefer-destructuring
                        models = device[1][0];
                    }
                }
            }
            return models;
        }
        return models;
    }

    if (mobileDevice === undefined) {
        mobileDevice = {};
    }

    mobileDevice.getGlRenderer = getGlRenderer;
    mobileDevice.getModels = getModels;
    mobileDevice.getResolution = getResolution;

    mobileDevice.is = () => getModels();
    return mobileDevice.is();
}

/**
 * @description CheckMobileBiometricType.
 * @returns {BiometricType} - BiometricType.
 */
export const checkMobileBiometricType = () => {
    const model = checkMobileDeviceModel();
    if (model.match(/iPhone+(X|12|13|14)/)) return BiometricType.faceId;
    return BiometricType.touch;
};
